// extracted by mini-css-extract-plugin
export default {"heading":"ZA-z","corrected":"_A-z","redirectVerbiageContainer":"aB-z","redirectVerbiageText":"bB-z"};